<template>
    <div class="container">
        <div class="col-xs-12">
            <div>
                <div class="title-color" :style="{ '--color' : document.non_repeat.titleColor}">
                    <div id="documentTitle" class="document-title" v-html="document.non_repeat.title"></div>
                </div>
                <div class="flex-card">
                    <div v-if="policyDocument['avb_text']">
                        <div class="card-style">
                            <span class="glyphicon glyphicon-download-alt sign-card distance"
                                  :style="{ '--color' : document.non_repeat.iconColor}"></span>
                            <a id="avb" class="item-style" target="_blank" :href="policyDocument['avb']"
                               v-text="policyDocument['avb_text']"></a>
                        </div>
                    </div>
                    <div v-if="policyDocument['ipid_text']">
                        <div class="card-style">
                            <span class="glyphicon glyphicon-download-alt sign-card distance"
                                  :style="{ '--color' : document.non_repeat.iconColor}"></span>
                            <a id="ipid" class="item-style" target="_blank" :href="policyDocument['ipid']"
                               v-text="policyDocument['ipid_text']"></a>
                        </div>
                    </div>
                    <div v-if="policyDocument['legal_notice_text']">
                        <div class="card-style">
                            <span class="glyphicon glyphicon-download-alt sign-card distance"
                                  :style="{ '--color' : document.non_repeat.iconColor}"></span>
                            <a id="legal_notice" class="item-style" target="_blank"
                               :href="policyDocument['legal_notices']"
                               v-text="policyDocument['legal_notice_text']"></a>
                        </div>
                    </div>
                    <div v-if="policyDocument['personal_data_collection_text']">
                        <div class="card-style">
                            <span class="glyphicon glyphicon-download-alt sign-card distance"
                                  :style="{ '--color' : document.non_repeat.iconColor}"></span>
                            <a id="personal_data_collection_text" class="item-style" target="_blank"
                               :href="policyDocument['personal_data_collection_notices']"
                               v-text="policyDocument['personal_data_collection_text']"></a>
                        </div>
                    </div>
                    <div v-if="policyDocument['cancellation_policy_text']">
                        <div class="card-style">
                            <span class="glyphicon glyphicon-download-alt sign-card distance"
                                  :style="{ '--color' : document.non_repeat.iconColor}"></span>
                            <a id="cancellation_policy" class="item-style" target="_blank"
                               :href="policyDocument['cancellation_policy']"
                               v-text="policyDocument['cancellation_policy_text']"></a>
                        </div>
                    </div>
                    <div v-if="policyDocument['legal_document_text']">
                        <div class="card-style">
                            <span class="glyphicon glyphicon-download-alt sign-card distance"
                                  :style="{ '--color' : document.non_repeat.iconColor}"></span>
                            <a id="legal_document" class="item-style" target="_blank"
                               :href="policyDocument['legal_document']"
                               v-text="policyDocument['legal_document_text']"></a>
                        </div>
                    </div>
                </div>
                <div id="bundleDocuments">
                    <div id="bundleDocumentHeadline" class="bundle-document-title" v-html="document.non_repeat.bundleDocumentsHeadline"></div>
                    <div class="flex-card">
                        <div v-if="filteredBundleDocuments['avb']">
                            <div class="card-style">
                                <span class="glyphicon glyphicon-download-alt sign-card distance"
                                    :style="{ '--color' : document.non_repeat.iconColor}"></span>
                                <a id="bundle-avb" class="item-style" target="_blank" :href="filteredBundleDocuments['avb']"
                                   v-text="bundleDocuments['avb_text']"></a>
                            </div>
                        </div>
                        <div v-if="filteredBundleDocuments['ipid']">
                            <div class="card-style">
                                <span class="glyphicon glyphicon-download-alt sign-card distance"
                                    :style="{ '--color' : document.non_repeat.iconColor}"></span>
                                <a id="bundle-ipid" class="item-style" target="_blank" :href="filteredBundleDocuments['ipid']"
                                   v-text="bundleDocuments['ipid_text']"></a>
                            </div>
                        </div>
                        <div v-if="filteredBundleDocuments['legal_notice']">
                            <div class="card-style">
                                <span class="glyphicon glyphicon-download-alt sign-card distance"
                                    :style="{ '--color' : document.non_repeat.iconColor}"></span>
                                <a id="bundle-legal_notice" class="item-style" target="_blank"
                                   :href="filteredBundleDocuments['legal_notices']"
                                   v-text="bundleDocuments['legal_notice_text']"></a>
                            </div>
                        </div>
                        <div v-if="filteredBundleDocuments['personal_data_collection']">
                            <div class="card-style">
                                <span class="glyphicon glyphicon-download-alt sign-card distance"
                                    :style="{ '--color' : document.non_repeat.iconColor}"></span>
                                <a id="bundle-personal_data_collection_text" class="item-style" target="_blank"
                                   :href="filteredBundleDocuments['personal_data_collection_notices']"
                                   v-text="bundleDocuments['personal_data_collection_text']"></a>
                            </div>
                        </div>
                        <div v-if="filteredBundleDocuments['cancellation_policy']">
                            <div class="card-style">
                                <span class="glyphicon glyphicon-download-alt sign-card distance"
                                    :style="{ '--color' : document.non_repeat.iconColor}"></span>
                                <a id="bundle-cancellation_policy" class="item-style" target="_blank"
                                   :href="filteredBundleDocuments['cancellation_policy']"
                                   v-text="bundleDocuments['cancellation_policy_text']"></a>
                            </div>
                        </div>
                        <div v-if="filteredBundleDocuments['legal_document']">
                            <div class="card-style">
                                <span class="glyphicon glyphicon-download-alt sign-card distance"
                                    :style="{ '--color' : document.non_repeat.iconColor}"></span>
                                <a id="bundle-legal_document" class="item-style" target="_blank"
                                   :href="filteredBundleDocuments['legal_document']"
                                   v-text="bundleDocuments['legal_document_text']"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Helper from '../helper'

export default {
    name: "DocumentSection",
    props: ['document', 'policyDocument', 'bundleDocuments'],
    mounted() {
        this.document.repeat;
    },
    computed: {
        filteredBundleDocuments: function () {
            const documents = {
                avb: null,
                cancellation_policy: null,
                ipid: null,
                legal_notices: null,
                personal_data_collection_notices: null
            }

            if (Helper.getOriginalFilename(this.bundleDocuments.avb) !== Helper.getOriginalFilename(this.policyDocument.avb)) {
                documents.avb = this.bundleDocuments.avb
            }

            if (Helper.getOriginalFilename(this.bundleDocuments.cancellation_policy) !== Helper.getOriginalFilename(this.policyDocument.cancellation_policy)) {
                documents.cancellation_policy = this.bundleDocuments.cancellation_policy
            }

            if (Helper.getOriginalFilename(this.bundleDocuments.ipid) !== Helper.getOriginalFilename(this.policyDocument.ipid)) {
                documents.ipid = this.bundleDocuments.ipid
            }

            if (Helper.getOriginalFilename(this.bundleDocuments.legal_notices) !== Helper.getOriginalFilename(this.policyDocument.legal_notices)) {
                documents.legal_notices = this.bundleDocuments.legal_notices
            }

            if (Helper.getOriginalFilename(this.bundleDocuments.personal_data_collection_notices) !== Helper.getOriginalFilename(this.policyDocument.personal_data_collection_notices)) {
                documents.personal_data_collection_notices = this.bundleDocuments.personal_data_collection_notices
            }

            return documents;
        }
    }
}
</script>

<style scoped lang="scss">

@import "../../css/variables.scss";

.container {
    margin-bottom: 50px;
}

.document-title {
    margin-bottom: 55px;
    padding-top: 57px;
    margin-left: 18rem;
}

.bundle-document-title {
    padding-bottom: 10px;
    margin-left: 18rem;
}

.card-style {
    border: 0.5px solid #B0B0B0;
    border-radius: 10px;
    margin-right: 20px;
    display: flex;
    width: auto;
    height: 82px;
    margin-bottom: 31px;
    color: $color-jungle-green;

    @media (min-width: $sm-breakpoint-min) {
        width: 360px;
        margin-left: 10px;
    }
}

a {
    color: black;
}

.card-style:hover {
    border-color: $color-black-russian;
    background-color: $color-jungle-green;
    color: $color-lime-yellow;
}

.card-style:hover .item-style {
    color: $color-lime-yellow;
}

.sign-card {
    font-size: 14px;
    margin-top: 17px;
    margin-left: 25px;
}

.flex-card {
    display: flex;
    margin-left: 18rem;
    flex-wrap: wrap;
}

.distance {
    margin-right: 10px;
}

.item-style {
    padding: 11px 50px 20px 8px;
    font-family: 'Open Sans';
    font-weight: bold;
    color: $color-jungle-green;
}

@media (max-width: 992px) {
    .flex-card {
        display: list-item;
        margin-left: 0;
        list-style: none;
    }

    .card-style {
        height: 82px;
        margin-bottom: 1rem;
        margin-right: 0;
    }

    .document-title {
        margin-left: 0;
        padding-top: 20px;
    }
}
</style>
